// @ts-nocheck

import { MODULE_ACL, AI_AGENT_DESCRIPTION_CHAR_LIMIT } from './constant';
import { isAclModuleOptionsRelevant } from './aclModuleOptionsAccess';
import { parseModuleOperations } from './voicePlanAcl';
import { getUser } from './setting';

export const AI_AGENT_ACL_MODULE = MODULE_ACL.AI_AGENT;


export const DEFAULT_AI_AGENT_DESC_CHAR_LIMIT = AI_AGENT_DESCRIPTION_CHAR_LIMIT;


export const AI_AGENT_DESC_LIMIT_PRESETS = [300, 500, 1000, 2000, 5000, 10000];

export function isAiAgentDescLimitConfigured(entry) {
  return typeof entry?.description_char_limit === 'number' && entry.description_char_limit > 0;
}

export function normalizeAiAgentDescLimitForSave(value) {
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) return DEFAULT_AI_AGENT_DESC_CHAR_LIMIT;
  return Math.floor(num);
}

export function formatAiAgentDescLimitAclLabel(moduleEntry) {
  if (!isAclModuleOptionsRelevant(moduleEntry)) return '—';
  if (!isAiAgentDescLimitConfigured(moduleEntry)) return '—';
  return `${moduleEntry.description_char_limit} chars`;
}

export function getAiAgentAclEntry(moduleOperations) {
  const ops = parseModuleOperations(moduleOperations);
  return ops[AI_AGENT_ACL_MODULE] || null;
}


export function getAiAgentDescriptionCharLimit() {
  try {
    const user = getUser();
    const raw = user?.acl_settings?.module_operations ?? user?.module_operations ?? null;
    const entry = getAiAgentAclEntry(raw);
    if (isAiAgentDescLimitConfigured(entry)) {
      return entry.description_char_limit;
    }
  } catch (e) {
  }
  return DEFAULT_AI_AGENT_DESC_CHAR_LIMIT;
}